{
  "version": "1.2.6",
  "objects": {
    "7493635533094543686": {
      "type": "frame",
      "id": "7493635533094543686",
      "z": 1896,
      "textContent": "",
      "left": 485.9971186167349,
      "top": 1387.9872161359663,
      "width": 400,
      "height": 500,
      "scaleX": 2.157790834474979,
      "scaleY": 1.201211144067711,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": null,
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": null,
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 30,
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7493635533103802369": {
      "type": "frame",
      "id": "7493635533103802369",
      "z": 1906,
      "textContent": "Frame 24",
      "left": 505.9971186167349,
      "top": 1407.9872161359663,
      "width": 400,
      "height": 500,
      "scaleX": 0.6959814757695858,
      "scaleY": 1.1212111440677108,
      "fill": "#FCC98D",
      "opacity": 0.05,
      "container": "7493635533094543686",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "Zz",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "parent",
      "layoutGap": "auto",
      "layoutPadding": 100,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7493635533104435131": {
      "type": "frame",
      "id": "7493635533104435131",
      "z": 1916,
      "textContent": "Frame 23",
      "left": 814.3897089245693,
      "top": 1407.9872161359663,
      "width": 400,
      "height": 500,
      "scaleX": 1.2868093587053935,
      "scaleY": 1.1212111440677108,
      "fill": "transparent",
      "opacity": 1,
      "container": "7493635533094543686",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 20,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7493635533091425950": {
      "type": "frame",
      "id": "7493635533091425950",
      "z": 1926,
      "textContent": "Frame 33",
      "left": 814.3897089245693,
      "top": 1933.1911041636054,
      "width": 400,
      "height": 500,
      "scaleX": 1.2868093587053935,
      "scaleY": 0.07080336801243266,
      "fill": "transparent",
      "opacity": 1,
      "container": "7493635533104435131",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a3",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "user",
      "layoutGap": 0,
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7493635533103320835": {
      "type": "wireframe",
      "id": "7493635533103320835",
      "z": 2026,
      "top": 1942.2656291040564,
      "left": 1090.318480795413,
      "width": 82.1650390625,
      "height": 33.859375,
      "scaleX": 0.5095378791048047,
      "scaleY": 0.5095378791048047,
      "container": "7493635533091425950",
      "layoutPosition": "a0",
      "wireframeName": "link",
      "fill": "#808080",
      "textColor": "#D88167",
      "style": "link",
      "fontSize": 14,
      "label": {},
      "placeholder": { "state": "default", "value": "Log in here" }
    },
    "7493635533091470280": {
      "type": "shape",
      "id": "7493635533091470280",
      "z": 2086,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#808080\">Already a customer?</span></p>",
      "left": 1010.318480795413,
      "top": 1942.3919461667135,
      "width": 137.94394706140034,
      "height": 29.313088750547575,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.5799457076894511,
      "scaleY": 0.5799457076894511,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 8.119239907652315,
      "angle": 0,
      "container": "7493635533091425950",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "Zz",
      "maskType": "none",
      "locked": false
    },
    "7493635533089803342": {
      "type": "frame",
      "id": "7493635533089803342",
      "z": 1936,
      "textContent": "Frame 46",
      "left": 1028.1288494540488,
      "top": 1407.9872161359663,
      "width": 400,
      "height": 500,
      "scaleX": 0.21811365605799538,
      "scaleY": 0.0001,
      "fill": "#C7DBAF",
      "opacity": 1,
      "container": "7493635533104435131",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": 0,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7493635533098086918": {
      "type": "frame",
      "id": "7493635533098086918",
      "z": 1946,
      "textContent": "Frame 46",
      "left": 814.3897089245693,
      "top": 1564.2829512077742,
      "width": 400,
      "height": 500,
      "scaleX": 1.2868093587053935,
      "scaleY": 0.6978163059116622,
      "fill": "transparent",
      "opacity": 1,
      "container": "7493635533104435131",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a2",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 30,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7493635533089254518": {
      "type": "frame",
      "id": "7493635533089254518",
      "z": 1956,
      "textContent": "Frame 45",
      "left": 937.8656860732144,
      "top": 1791.892885211726,
      "width": 400,
      "height": 500,
      "scaleX": 0.6694294729621675,
      "scaleY": 0.11475233514533807,
      "fill": "transparent",
      "opacity": 1,
      "container": "7493635533098086918",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 10,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7493635533089367633": {
      "type": "wireframe",
      "id": "7493635533089367633",
      "z": 1966,
      "top": 1791.892885211726,
      "left": 937.8656860732144,
      "width": 193.0615234375,
      "height": 24,
      "scaleX": 0.6432803495168745,
      "scaleY": 0.6432803495168745,
      "container": "7493635533089254518",
      "layoutPosition": "a1",
      "wireframeName": "checkbox",
      "fill": "#808080",
      "textColor": "#9D9D9D",
      "componentState": "empty",
      "uiState": "enabled",
      "fontSize": 14,
      "label": { "value": "Accept terms & conditions", "position": "right" },
      "placeholder": {}
    },
    "7493635533091728135": {
      "type": "wireframe",
      "id": "7493635533091728135",
      "z": 2016,
      "top": 1817.331613600131,
      "left": 937.8656860732144,
      "width": 333.1475512571533,
      "height": 39.859375,
      "scaleX": 0.8012528842778885,
      "scaleY": 0.8012528842778885,
      "container": "7493635533089254518",
      "layoutPosition": "a2",
      "wireframeName": "button",
      "fill": "#D88167",
      "textColor": null,
      "style": "squareFilled",
      "fontSize": 14,
      "label": {},
      "placeholder": { "state": "default", "value": "Sign up" },
      "setDimension": true
    },
    "7493635533099524301": {
      "type": "frame",
      "id": "7493635533099524301",
      "z": 1976,
      "textContent": "Frame 32",
      "left": 936.6900171799011,
      "top": 1689.66055919384,
      "width": 400,
      "height": 500,
      "scaleX": 0.6753078174287339,
      "scaleY": 0.1444646520357719,
      "fill": "transparent",
      "opacity": 1,
      "container": "7493635533098086918",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "Zz",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7493635533100666443": {
      "type": "wireframe",
      "id": "7493635533100666443",
      "z": 1996,
      "top": 1689.66055919384,
      "left": 937.7604787798152,
      "width": 353.034960372516,
      "height": 40,
      "scaleX": 0.7590812068269256,
      "scaleY": 0.7590812068269256,
      "container": "7493635533099524301",
      "layoutPosition": "ZyV",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#7E7B7B",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Password", "position": "noLabel" },
      "placeholder": {
        "state": "text",
        "value": "Password",
        "iconLeft": { "prefix": "fas", "iconName": "key" },
        "iconRight": null
      },
      "setDimension": true
    },
    "7493635533100626137": {
      "type": "wireframe",
      "id": "7493635533100626137",
      "z": 2006,
      "top": 1730.023807466917,
      "left": 937.4392790794657,
      "width": 337.16018433086816,
      "height": 40,
      "scaleX": 0.7967269436202254,
      "scaleY": 0.7967269436202254,
      "container": "7493635533099524301",
      "layoutPosition": "a0",
      "wireframeName": "inputField",
      "fill": "#E0E0E0",
      "textColor": "#A59898",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Password", "position": "noLabel" },
      "placeholder": {
        "state": "text",
        "value": "Confirm password",
        "iconLeft": { "prefix": "fas", "iconName": "key" },
        "iconRight": null
      },
      "setDimension": true
    },
    "7493635533092576936": {
      "type": "wireframe",
      "id": "7493635533092576936",
      "z": 1986,
      "top": 1627.2050025869844,
      "left": 937.0620894511194,
      "width": 330.8301875029372,
      "height": 39.859375,
      "scaleX": 0.814251518164936,
      "scaleY": 0.814251518164936,
      "container": "7493635533098086918",
      "layoutPosition": "Zy",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#7E7B7B",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Email", "position": "noLabel" },
      "placeholder": { "state": "text", "value": "Email " },
      "setDimension": true
    },
    "7493635533090678960": {
      "type": "frame",
      "id": "7493635533090678960",
      "z": 2046,
      "textContent": "Frame 31",
      "left": 814.3897089245693,
      "top": 1428.0372161359662,
      "width": 400,
      "height": 500,
      "scaleX": 1.2868093587053935,
      "scaleY": 0.232491470143616,
      "fill": "transparent",
      "opacity": 1,
      "container": "7493635533104435131",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1V",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "user",
      "layoutGap": 0,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7493635533093783285": {
      "type": "shape",
      "id": "7493635533093783285",
      "z": 2056,
      "shapeName": "text",
      "textContent": "<p>Join us today</p>",
      "left": 1033.751580665648,
      "top": 1500.3203818539027,
      "width": 92.1719075284101,
      "height": 29.106918166866343,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8245462423198149,
      "scaleY": 0.824546242319815,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.4,
      "textAlign": "left",
      "fontSize": 11.543647392477409,
      "angle": 0,
      "container": "7493635533090678960",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a0G",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7493635533095206416": {
      "type": "shape",
      "id": "7493635533095206416",
      "z": 2066,
      "shapeName": "text",
      "textContent": "<p>Get started for free</p>",
      "left": 981.2515806656479,
      "top": 1458.3203818539027,
      "width": 127.28757367075686,
      "height": 29.53634306172259,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.4219769831435092,
      "scaleY": 1.421976983143509,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 19.90767776400913,
      "angle": 0,
      "container": "7493635533090678960",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a0",
      "maskType": "none",
      "locked": false
    },
    "7493635533093699457": {
      "type": "shape",
      "id": "7493635533093699457",
      "z": 2076,
      "shapeName": "icon",
      "textContent": "",
      "left": 1056.6099978066798,
      "top": 1428.0372161359662,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.3028316571793641,
      "scaleY": 0.3028316571793641,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#D88167",
      "angle": 0,
      "container": "7493635533090678960",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "Zz",
      "maskType": "none",
      "iconName": "fas/fingerprint",
      "locked": false
    }
  }
}
